export const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatBRL(value) {
  const n = Number(value || 0);
  return BRL.format(n);
}

export function formatDate(value) {
  if (!value) return '-';
  try {
    const d = String(value).slice(0, 10);
    const [y, m, day] = d.split('-');
    if (y && m && day) return `${day}/${m}/${y}`;
    return new Date(value).toLocaleDateString('pt-BR');
  } catch (e) {
    return value;
  }
}

export function maskCPF(cpf) {
  if (!cpf) return '-';
  const digits = String(cpf).replace(/\D/g, '');
  if (digits.length < 5) return cpf;
  return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`;
}

export function roleHome(role) {
  if (role === 'cliente') return '/portal/viagens';
  if (['admin', 'supervisor', 'vendedor'].includes(role)) return '/erp/dashboard';
  return '/';
}

export function roleLabel(role) {
  return ({
    admin: 'Administrador',
    supervisor: 'Supervisor',
    vendedor: 'Vendedor',
    cliente: 'Cliente',
  })[role] || role;
}

const STATUS = {
  planejada: { label: 'Planejada', cls: 'bg-secondary text-secondary-foreground' },
  confirmada: { label: 'Confirmada', cls: 'bg-[hsl(174_55%_34%/0.15)] text-[hsl(174_55%_24%)]' },
  executada: { label: 'Executada', cls: 'bg-[hsl(198_78%_22%/0.12)] text-[hsl(198_78%_22%)]' },
  cancelada: { label: 'Cancelada', cls: 'bg-destructive/10 text-destructive' },
  aberta: { label: 'Aberta', cls: 'bg-[hsl(36_55%_55%/0.18)] text-[hsl(36_60%_35%)]' },
  paga: { label: 'Paga', cls: 'bg-[hsl(174_55%_34%/0.15)] text-[hsl(174_55%_24%)]' },
  novo: { label: 'Novo', cls: 'bg-[hsl(36_55%_55%/0.18)] text-[hsl(36_60%_35%)]' },
  em_contato: { label: 'Em contato', cls: 'bg-[hsl(198_78%_22%/0.12)] text-[hsl(198_78%_22%)]' },
  convertido: { label: 'Convertido', cls: 'bg-[hsl(174_55%_34%/0.15)] text-[hsl(174_55%_24%)]' },
  perdido: { label: 'Perdido', cls: 'bg-destructive/10 text-destructive' },
};

export function statusInfo(status) {
  return STATUS[status] || { label: status, cls: 'bg-secondary text-secondary-foreground' };
}
